import React from 'react'
import styled from 'styled-components'

// Components
import Heading from 'components/Heading'

import SectionPaidStudentRatio from 'components/analytics/dashboard/SectionPaidStudentRatio'
import SectionOrdersByMonth from 'components/analytics/dashboard/SectionOrdersByMonth'
import SectionOrdersByRegionAndCourse from 'components/analytics/dashboard/SectionOrdersByRegionAndCourse'
import SectionOrdersByCourseType from 'components/analytics/dashboard/SectionOrdersByCourseType'

// Hooks
import { useEditable } from 'hooks/useEditable'

const Dashboard = () => {
  useEditable()
  return (
    <Container>
      <Heading title='Dashboard' />
      <section>
        <SectionPaidStudentRatio />
        <SectionOrdersByMonth />
        <SectionOrdersByRegionAndCourse />
        <SectionOrdersByCourseType />
      </section>
    </Container>
  )
}

export default Dashboard

const Container = styled.div`
  padding-bottom: 100px;
`